export default {"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25};